import { Type } from "class-transformer";
import { addYears, subDays, endOfDay } from "date-fns";
import { startOfEDAZDistribution } from "config";
import type { EntityValidationRules } from "../services/validationService";
import type CreditExposureType from "./creditExposureType";
import type CreditExposureState from "./creditExposureState";

export default class CreditExposure {
  id: string;
  distributorName: string;
  type: CreditExposureType;
  amount: number;
  description: string;
  @Type(() => Date)
  validSinceDate: Date;
  @Type(() => Date)
  validUntilDate: Date;
  state: CreditExposureState;
  @Type(() => Date)
  updatedAt: Date;
  updatedUserId: string;
  distributorId?: string;
}

export const CreditExposureValidationRules: EntityValidationRules<CreditExposure> = {
  description: {
    required: true,
    isLength: {
      max: 255,
    },
  },
  distributorId: {
    required: true,
  },
  type: {
    required: true,
  },
  amount: {
    range: { min: 1, max: 100000000000 },
    required: true,
  },
  validSinceDate: {
    required: true,
    isBefore: {
      condition: (entity: CreditExposure) => entity.validUntilDate,
    },
    isAfter: {
      condition: () => endOfDay(subDays(startOfEDAZDistribution, 1)),
    },
  },
  validUntilDate: {
    required: true,
    isAfter: {
      condition: (entity: CreditExposure) => (entity.validSinceDate > new Date() ? entity.validSinceDate : new Date()),
    },
    isBefore: {
      condition: () => endOfDay(addYears(new Date(), 1)),
    },
  },
};
